<template>
  <div
    id="m_aside_left"
    class="m-grid__item m-aside-left m-aside-left--skin-light"
    style="z-index: 700000"
  >
    <!-- BEGIN: Aside Menu -->
    <div
      id="m_ver_menu"
      :class="menuWrapperClass"
      data-menu-vertical="true"
      m-menu-scrollable="1"
      m-menu-dropdown-timeout="500"
    >
      <ul class="m-menu__nav m-menu__nav--dropdown-submenu-arrow">
        <li
          class="m-menu__item m-menu__item--submenu"
          aria-haspopup="true"
          m-menu-link-redirect="1"
          v-if="productAccess"
        >
          <router-link to="/dashboard/manage-products" class="m-menu__link"
            ><i class="m-menu__link-icon flaticon-cogwheel"></i>
            <span class="m-menu__link-title">
              <span class="m-menu__link-wrap">
                <span class="m-menu__link-text">{{
                  labels["manage_products_title"]
                }}</span>
              </span>
            </span>
          </router-link>
        </li>
        <li
          class="m-menu__item m-menu__item--submenu"
          aria-haspopup="true"
          m-menu-link-redirect="1"
          v-if="stockAccess"
        >
          <router-link to="/dashboard/manage-stock" class="m-menu__link"
            ><i class="m-menu__link-icon flaticon-pie-chart"></i>
            <span class="m-menu__link-title">
              <span class="m-menu__link-wrap">
                <span class="m-menu__link-text">{{
                  labels["manage_stock_title"]
                }}</span>
              </span>
            </span>
          </router-link>
        </li>
        <li
          class="m-menu__item m-menu__item--submenu"
          aria-haspopup="true"
          m-menu-link-redirect="1"
          v-if="resourceAccess || researchRole"
        >
          <router-link
            to="/dashboard/amoire-technique/themes"
            class="m-menu__link"
            ><i class="m-menu__link-icon la la-cubes"></i>
            <span class="m-menu__link-title">
              <span class="m-menu__link-wrap">
                <span class="m-menu__link-text">{{
                  labels["manage_theme_segmentations"] | capitalize
                }}</span>
              </span>
            </span>
          </router-link>
        </li>
        <li
          :class="subMenuClass"
          aria-haspopup="true"
          m-menu-submenu-toggle="hover"
          v-if="resourceAccess"
        >
          <a
            @click.prevent="toggleSubMenu"
            href="#"
            class="m-menu__link m-menu__toggle"
          >
            <i class="m-menu__link-icon flaticon-layers"></i>
            <span class="m-menu__link-text">{{
              labels["resources_title"]
            }}</span>
            <i class="m-menu__ver-arrow la la-angle-right"></i>
          </a>
          <div class="m-menu__submenu" m-hidden-height="160">
            <span class="m-menu__arrow"></span>
            <ul
              class="m-menu__subnav"
              style="height: 400px; overflow: hidden; overflow-y: scroll"
            >
              <li
                class="m-menu__item m-menu__item--parent"
                aria-haspopup="true"
              >
                <span class="m-menu__link"
                  ><span class="m-menu__link-text">{{
                    labels["resources_title"]
                  }}</span></span
                >
              </li>
              <li
                class="m-menu__item"
                aria-haspopup="true"
                m-menu-link-redirect="1"
                v-for="(resource, key) in orderResources"
                :key="key"
              >
                <router-link
                  :to="'/dashboard/resources/' + resource"
                  class="m-menu__link"
                >
                  <i class="m-menu__link-bullet m-menu__link-bullet--dot"
                    ><span></span
                  ></i>
                  <span class="m-menu__link-text">{{
                    labels.resources[resource]
                  }}</span>
                </router-link>
              </li>
            </ul>
          </div>
        </li>
        <li
          class="m-menu__item m-menu__item--submenu"
          aria-haspopup="true"
          m-menu-link-redirect="1"
          v-if="userAccess"
        >
          <router-link to="/dashboard/admin/manage-users" class="m-menu__link"
            ><i class="m-menu__link-icon flaticon-user-settings"></i>
            <span class="m-menu__link-title">
              <span class="m-menu__link-wrap">
                <span class="m-menu__link-text">{{
                  labels["manage_users_title"]
                }}</span>
              </span>
            </span>
          </router-link>
        </li>

        <li
          class="m-menu__item m-menu__item--submenu"
          aria-haspopup="true"
          m-menu-link-redirect="1"
          v-if="adminRole"
        >
          <a
            href="#"
            class="m-menu__link"
            data-target="#m_modal_imports"
            data-toggle="modal"
            @click.prevent="updateImportType('productComplex')"
          >
            <i class="m-menu__link-icon flaticon-upload"></i>
            <span class="m-menu__link-title">
              <span class="m-menu__link-wrap">
                <span class="m-menu__link-text">{{
                  labels["import_product_complex"]
                }}</span>
              </span>
            </span>
          </a>
        </li>

        <li
          class="m-menu__item m-menu__item--submenu"
          aria-haspopup="true"
          m-menu-link-redirect="1"
          v-if="adminRole"
        >
          <router-link to="/dashboard/admin/manage-exports" class="m-menu__link"
            ><i class="m-menu__link-icon flaticon-user-settings"></i>
            <span class="m-menu__link-title">
              <span class="m-menu__link-wrap">
                <span class="m-menu__link-text">{{
                  labels["export"] | capitalize
                }}</span>
              </span>
            </span>
          </router-link>
        </li>

        <div class="ps__rail-x" style="left: 0px; bottom: -1917px">
          <div
            class="ps__thumb-x"
            tabindex="0"
            style="left: 0px; width: 0px"
          ></div>
        </div>
        <div class="ps__rail-y" style="top: 1917px; height: 200px; right: 4px">
          <div
            class="ps__thumb-y"
            tabindex="0"
            style="top: 105px; height: 40px"
          ></div>
        </div>
      </ul>
    </div>

    <!-- END: Aside Menu -->
  </div>
</template>

<script>
import '../../../theme/default/dist/demo6/assets/demo/demo6/base/scripts.bundle';
import { mapState, mapActions, mapGetters } from 'vuex';

export default {
  name: 'Sidebar',
  data() {
    return {
      subMenuOpen: false,
      menuWrapperClass:
        'm-aside-menu  m-aside-menu--skin-light m-aside-menu--submenu-skin-light',
    };
  },
  computed: {
    ...mapState({
      labels: (state) => state.labels,
      resources: (state) => state.crudData.cruds,
      sessionUser: (state) => state.sessionUser,
    }),
    ...mapGetters([
      'productAccess',
      'stockAccess',
      'resourceAccess',
      'userAccess',
      'adminRole',
      'researchRole',
    ]),
    subMenuClass() {
      if (this.subMenuOpen) {
        this.menuWrapperClass = 'm-aside-menu m-aside-menu--skin-light m-aside-menu--submenu-skin-light m-scroller ps ps--active-y';
        return 'm-menu__item m-menu__item--submenu m-menu__item--hover m-menu__item--open';
      }
      this.menuWrapperClass = 'm-aside-menu  m-aside-menu--skin-light m-aside-menu--submenu-skin-light';
      return 'm-menu__item  m-menu__item--submenu';
    },
    orderResources() {
      const translations = Object.keys(this.labels.resources).filter(
        (name) => name !== 'segmentations' && name !== 'themes',
      );
      const my = this;
      return translations.sort((a, b) => {
        const labelA = my.labels.resources[a];
        const labelB = my.labels.resources[b];
        if (labelA < labelB) {
          return -1;
        }
        if (labelA > labelB) {
          return 1;
        }
        return 0;
      });
    },
  },
  methods: {
    ...mapActions(['updateImportType']),
    toggleSubMenu(e) {
      e.stopPropagation();
      // Toggle the subMenu open status
      this.subMenuOpen = !this.subMenuOpen;
    },
  },
  mounted() {
    // Add listener to close the submenu on any doc click
    const my = this;
    document.addEventListener('click', () => {
      my.subMenuOpen = false;
      $('body').removeClass('m-aside-left--minimize-hover');
      $('body').addClass('m-aside-left--minimize');
    });

    $(document).on('click', '.m-menu__nav--dropdown-submenu-arrow', () => {
      my.subMenuOpen = true;
      $('body').removeClass('m-aside-left--minimize');
      $('body').addClass('m-aside-left--minimize-hover');
    });

    $(document).on('mouseenter', '.m-menu__nav--dropdown-submenu-arrow', () => {
      $('body').removeClass('m-aside-left--minimize');
      $('body').addClass('m-aside-left--minimize-hover');
    });

    $(document).on('mouseleave', '.m-menu__nav--dropdown-submenu-arrow', () => {
      my.subMenuOpen = false;
      $('body').addClass('m-aside-left--minimize');
      $('body').removeClass('m-aside-left--minimize-hover');
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Admin/SideBar.vue